// Vendor libraries
import { EventEmitter, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils
import cloneDeep from 'lodash.clonedeep';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
// NgRx
import { getCurrentWizardStep, getCurrentWizardStepIndex, getSelectedReport, getTransitionAnalyses, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { setTransitionAnalyses } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/transition_analyses/transition-analyses.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { updateCustomPDFReportWizardStep } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/state/custom-pdf-reports/custom-pdf-reports.actions';
import { updateSelectedReportWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function SelectTransitionAnalysisModalComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td");
    i0.ɵɵelementStart(2, "td")(3, "label", 9)(4, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function SelectTransitionAnalysisModalComponent_tr_14_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.selectedTransitionAnalysis, $event) || (ctx_r1.selectedTransitionAnalysis = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_tr_14_Template_input_click_4_listener() { const analysis_r3 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateSelectedTransitionAnalysis(analysis_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 11);
    i0.ɵɵelementStart(6, "span", 12);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const analysis_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedTransitionAnalysis);
    i0.ɵɵproperty("value", analysis_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getTitle(analysis_r3), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(analysis_r3.createdDate);
} }
/**
 * Select Transition Analysis Modal Component
 *
 * Used for selecting a Transition Analysis used for a module in the Custom PDF Reports in the wizard steps
 *
 * Input Properties:
 *  transitionAnalysisList: Array of SerializedTransitionAnalysis representing transition analysis available for user to choose
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class SelectTransitionAnalysisModalComponent {
    constructor(ngZone, featureService, store) {
        this.ngZone = ngZone;
        this.featureService = featureService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentWizardStep = null;
        this.cancelButtonText = 'Back';
        this.submitButtonText = 'Next';
        this.sortColumn = 'weighting';
        this.sortDirection = DESC;
        this.mapStateToComponent = (state) => {
            const selectedReport = getSelectedReport(state);
            this.reportId = selectedReport.report_id;
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            if (!this.modalOpen &&
                this.currentWizardStepIndex === 0 &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_TRANSITION_ANALYSIS_MODAL) {
                this.openModal();
            }
            if (this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_TRANSITION_ANALYSIS_MODAL) {
                if (this.currentWizardStep.modules === undefined) {
                    this.modules = [];
                }
                else {
                    this.modules = this.currentWizardStep.modules;
                }
            }
            this.transitionAnalysesModuleMap = getTransitionAnalyses(state);
        };
        this.moduleMapHasModuleData = (module) => {
            return this.transitionAnalysesModuleMap[module.step_uuid] !== undefined;
        };
        this.infoMessage = '';
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        if (Object.keys(this.transitionAnalysesModuleMap).length === 0) {
            this.selectTransitionAnalysisModalStepIndex = 0;
        }
        const transitionAnalysesModuleMap = cloneDeep(this.transitionAnalysesModuleMap);
        this.store.dispatch(setTransitionAnalyses({ transitionAnalyses: transitionAnalysesModuleMap }));
        this.modalOpen = true;
        this.initializeSelectTransitionAnalysisModal();
    }
    initializeSelectTransitionAnalysisModal() {
        const module = this.modules[this.selectTransitionAnalysisModalStepIndex];
        this.title = 'Select Saved Transition Analysis';
        this.selectedTransitionAnalysis = this.moduleMapHasModuleData(module)
            ? this.transitionAnalysesModuleMap[module.step_uuid]
            : undefined;
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    forward() {
        const module = this.modules[this.selectTransitionAnalysisModalStepIndex];
        const transitionAnalysesModuleMap = cloneDeep(this.transitionAnalysesModuleMap);
        if (this.selectedTransitionAnalysis !== undefined) {
            transitionAnalysesModuleMap[module.id] = this.selectedTransitionAnalysis;
            transitionAnalysesModuleMap[module.step_uuid] = this.selectedTransitionAnalysis;
        }
        this.store.dispatch(setTransitionAnalyses({ transitionAnalyses: transitionAnalysesModuleMap }));
        const updatedWizardStep = cloneDeep(this.currentWizardStep);
        if (updatedWizardStep?.modules !== undefined) {
            // update the step in the original list of reports
            this.store.dispatch(updateCustomPDFReportWizardStep({ newStep: updatedWizardStep, customPDFReportId: this.reportId }));
            // update the step in the report data in the modal
            this.store.dispatch(updateSelectedReportWizardStep({ newStep: updatedWizardStep }));
        }
        if (this.selectTransitionAnalysisModalStepIndex + 1 < this.modules.length) {
            this.selectTransitionAnalysisModalStepIndex += 1;
            this.initializeSelectTransitionAnalysisModal();
        }
        else {
            this.closeModal();
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
    back() {
        if (this.selectTransitionAnalysisModalStepIndex > 0) {
            this.selectTransitionAnalysisModalStepIndex -= 1;
            this.initializeSelectTransitionAnalysisModal();
        }
        else {
            this.closeModal();
            if (this.currentWizardStepIndex) {
                this.store.dispatch(decrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
    closeModal() {
        this.modalOpen = false;
        this.infoMessage = '';
        this.selectedTransitionAnalysis = undefined;
    }
    getSortNgClass(columnName) {
        if (columnName === this.sortColumn) {
            if (this.sortDirection === DESC)
                return 'th-sort-desc';
            if (this.sortDirection === ASC)
                return 'th-sort-asc';
        }
        return '';
    }
    /**
     * Sets sort column and sort direction when a column header is clicked
     * @param columnName: New sort column name.
     */
    setTableSortProperties(columnName) {
        if (columnName === this.sortColumn) {
            this.sortDirection = this.sortDirection === ASC ? DESC : ASC;
        }
        else {
            this.sortColumn = columnName;
            this.sortDirection = ASC;
        }
        const asc_or_desc = this.sortDirection === ASC ? 1 : -1;
        this.transitionAnalysisList.sort((a, b) => {
            const nameA = this.getTitle(a);
            const nameB = this.getTitle(b);
            const dateA = a.createdDate;
            const dateB = b.createdDate;
            if (this.sortColumn === 'analysis_name') {
                if (nameA < nameB)
                    return -1 * asc_or_desc;
                if (nameA > nameB)
                    return asc_or_desc;
                return 0;
            }
            if (dateA < dateB)
                return -1 * asc_or_desc;
            if (dateA > dateB)
                return asc_or_desc;
            return 0;
        });
    }
    updateSelectedTransitionAnalysis(selected_analysis) {
        this.selectedTransitionAnalysis = selected_analysis;
    }
    getTitle(analysis) {
        if (analysis === undefined || analysis === null) {
            return 'Select Transition Analysis';
        }
        return `${analysis.transition_strategy}: ${analysis.initialPortfolio} to ${analysis.targetPortfolio}`;
    }
}
SelectTransitionAnalysisModalComponent.ɵfac = function SelectTransitionAnalysisModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectTransitionAnalysisModalComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.Store)); };
SelectTransitionAnalysisModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectTransitionAnalysisModalComponent, selectors: [["ycn-select-transition-analysis-modal"]], inputs: { transitionAnalysisList: "transitionAnalysisList" }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 16, vars: 10, consts: [[3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "table", "table-airy", "table-hover"], [1, "col-1"], [1, "col-6", 3, "click", "ngClass"], [1, "col-4", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [3, "cancelHandler", "submitHandler", "modalTestId", "disableSubmission", "cancelButtonText", "submitButtonText"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "radio-scenario", 1, "custom-control-input", "pointer-events-none", "ng-pristine", "ng-valid", "ng-not-empty", "ng-touched", 3, "ngModelChange", "click", "ngModel", "value"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function SelectTransitionAnalysisModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "table", 3)(4, "thead");
        i0.ɵɵelement(5, "th", 4);
        i0.ɵɵelementStart(6, "th", 5);
        i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_Template_th_click_6_listener() { return ctx.setTableSortProperties("analysis_name"); });
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "Name");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "th", 6);
        i0.ɵɵlistener("click", function SelectTransitionAnalysisModalComponent_Template_th_click_9_listener() { return ctx.setTableSortProperties("date_modified"); });
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11, "Date Modified");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(12, "th", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "tbody");
        i0.ɵɵtemplate(14, SelectTransitionAnalysisModalComponent_tr_14_Template, 11, 4, "tr", 7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "ycn-simple-modal-footer", 8);
        i0.ɵɵlistener("cancelHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_simple_modal_footer_cancelHandler_15_listener() { return ctx.back(); })("submitHandler", function SelectTransitionAnalysisModalComponent_Template_ycn_simple_modal_footer_submitHandler_15_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("analysis_name"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getSortNgClass("date_modified"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.transitionAnalysisList);
        i0.ɵɵadvance();
        i0.ɵɵproperty("modalTestId", "select-transition-analysis-modal")("disableSubmission", ctx.selectedTransitionAnalysis === undefined)("cancelButtonText", ctx.cancelButtonText)("submitButtonText", ctx.submitButtonText);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i4.DefaultValueAccessor, i4.RadioControlValueAccessor, i4.NgControlStatus, i4.NgModel, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
